__turbopack_context__.v({
  "attention": "NewOrderPanel-module-scss-module__QzxchW__attention",
  "body": "NewOrderPanel-module-scss-module__QzxchW__body",
  "closeButton": "NewOrderPanel-module-scss-module__QzxchW__closeButton",
  "content": "NewOrderPanel-module-scss-module__QzxchW__content",
  "current": "NewOrderPanel-module-scss-module__QzxchW__current",
  "done": "NewOrderPanel-module-scss-module__QzxchW__done",
  "dot": "NewOrderPanel-module-scss-module__QzxchW__dot",
  "edit": "NewOrderPanel-module-scss-module__QzxchW__edit",
  "header": "NewOrderPanel-module-scss-module__QzxchW__header",
  "line": "NewOrderPanel-module-scss-module__QzxchW__line",
  "nextButton": "NewOrderPanel-module-scss-module__QzxchW__nextButton",
  "panel": "NewOrderPanel-module-scss-module__QzxchW__panel",
  "placeholder": "NewOrderPanel-module-scss-module__QzxchW__placeholder",
  "rail": "NewOrderPanel-module-scss-module__QzxchW__rail",
  "step": "NewOrderPanel-module-scss-module__QzxchW__step",
  "stepHeader": "NewOrderPanel-module-scss-module__QzxchW__stepHeader",
  "stepLabel": "NewOrderPanel-module-scss-module__QzxchW__stepLabel",
  "stepText": "NewOrderPanel-module-scss-module__QzxchW__stepText",
  "stepValue": "NewOrderPanel-module-scss-module__QzxchW__stepValue",
  "steps": "NewOrderPanel-module-scss-module__QzxchW__steps",
  "title": "NewOrderPanel-module-scss-module__QzxchW__title",
});
